<template>
    <div>
        <modal
            :name="'modal-view-intervention-' + interventionId"
            :width="modalWidth"
            height="auto"
            :scrollable="true"
        >
            <!-- CONTENT -->
            <div class="bg-gray-50 rounded-lg shadow-inner">
                <div v-if="loadingGetIntervention">
                    <div class="p-8">
                        <div class="flex items-center gap-3 text-gray-500 justify-center py-8">
                            <i class="fas fa-spinner fa-spin text-xl"></i>
                            Chargement de l'intervention...
                        </div>
                    </div>
                </div>
                <div v-if="intervention && !loadingGetIntervention">
                    <!-- HEADER -->
                    <div class="bg-white flex flex-col md:flex-row md:items-center md:justify-between px-6 md:px-8 pt-8 pb-4 border-b border-gray-200">
                        
                        <!-- TITLE -->
                        <div class="mb-4 md:mb-0">
                            <h2 class="font-bold text-xl md:text-2xl text-gray-800 flex items-center gap-2">
                                {{ intervention.reference }}
                            </h2>

                            <div class="mt-3 flex flex-wrap items-center gap-2">
                                <span
                                    class="px-3 py-1 rounded-full text-xs font-semibold"
                                    :class="statusClass(intervention.statut?.code)"
                                >
                                    {{ intervention.statut?.libelle }}
                                </span>

                                <span
                                    v-if="intervention.date_intervention"
                                    class="px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700 flex items-center gap-1"
                                >
                                    <i class="far fa-calendar"></i> {{ intervention.date_intervention | momentDate }}
                                </span>

                                <span
                                    v-if="intervention.heure_debut || intervention.heure_fin"
                                    class="px-3 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700 flex items-center gap-1"
                                >
                                    <i class="far fa-clock"></i>
                                    {{ intervention.heure_debut.slice(0,5) }} → {{ intervention.heure_fin.slice(0,5) }}
                                </span>
                            </div>
                        </div>

                        <!-- CLOSE BUTTON -->
                        <button
                            @click="$modal.hide('modal-view-intervention-' + interventionId)"
                            class="text-gray-500 hover:text-red-500 self-end md:self-auto transition"
                        >
                            <i class="fas fa-times text-xl"></i>
                        </button>
                    </div>

                    <!-- BODY -->
                    <div class="flex flex-col md:flex-row">

                        <!-- SIDEBAR -->
                        <div class="md:w-1/4 bg-white border-b md:border-b-0 md:border-r border-gray-200 p-4 md:p-6 flex md:flex-col overflow-x-auto md:overflow-visible gap-2">
                            <div v-for="tab in tabs" :key="tab.label">
                                <div @click="activeTab = tab.label" class="flex items-center gap-3 px-4 py-3 whitespace-nowrap rounded-lg cursor-pointer transition-all duration-200" :class="activeTab === tab.label  ? 'bg-red-600 text-white shadow-md' : 'text-gray-700 hover:bg-red-50 hover:text-red-600'">
                                    <i :class="tab.icon"></i>
                                    <span class="font-medium text-sm">{{ tab.label }}</span>
                                </div>
                            </div>
                            <template v-if="intervention.statut?.code === 'planifie'">
                                <div @click="activeTab = 'Déplanifier'" class="flex items-center gap-3 px-4 py-3 whitespace-nowrap rounded-lg cursor-pointer transition-all duration-200" :class="activeTab === 'Déplanifier'  ? 'bg-red-600 text-white shadow-md' : 'text-gray-700 hover:bg-red-50 hover:text-red-600'">
                                    <i class="fas fa-calendar-times"></i>
                                    <span class="font-medium text-sm">Déplanifier</span>
                                </div>
                            </template>
                        </div>

                        <!-- CONTENT -->
                        <div class="md:w-3/4 p-4 md:p-8">
                            <transition name="fade" mode="out-in">
                                <div
                                    :key="activeTab"
                                    class="bg-white rounded-xl shadow p-4 md:p-6 border border-gray-100"
                                >

                                    <!-- INFOS -->
                                    <div v-if="activeTab === 'Infos'" class="space-y-4">
                                        <!-- <div v-if="emptySignature" class="bg-orange-100 text-orange-600 p-4 rounded-lg">
                                            <div>Attention : la signature client est manquante pour cette intervention planifiée.</div>
                                            <div class="mt-2">
                                                <button @click="sendSignature" class="px-4 py-2 bg-orange-600 hover:bg-orange-700 text-white rounded-lg text-sm font-semibold">
                                                    <i class="fas fa-paper-plane mr-1"></i> Envoyer la demande de signature
                                                </button>
                                            </div>
                                        </div> -->
                                        <div class="grid grid-cols-2 gap-4">
                                            <div>
                                                <h3 class="font-semibold text-gray-700 mb-1">Référence</h3>
                                                <p class="text-gray-600">{{ intervention.reference }}</p>
                                            </div>
                                            <div class="flex items-center gap-4 justify-between">
                                                <div>
                                                    <div>
                                                        <h3 class="font-semibold text-gray-700 mb-1">Statut</h3>
                                                        <p class="text-gray-600 bg-gray-200 font-bold p-1.5 px-4 rounded text-sm">{{ intervention.statut?.libelle }}</p>
                                                    </div>
                
                                                    <div v-if="intervention.type">
                                                        <h3 class="font-semibold text-gray-700 mb-1">Type</h3>
                                                        <p class="text-gray-600">{{ intervention.type }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="intervention.notes_internes">
                                            <h3 class="font-semibold text-gray-700 mb-1">Notes internes</h3>
                                            <p class="text-gray-600">{{ intervention.notes_internes }}</p>
                                        </div>

                                        <div v-if="intervention.intervention_type">
                                            <h3 class="font-semibold text-gray-700 mb-1">Type d'intervention</h3>
                                            <p class="text-gray-600">{{ intervention.intervention_type?.nom }}</p>
                                        </div>

                                    </div>

                                    <!-- CLIENT -->
                                    <div v-if="activeTab === 'Client'">
                                        <client-form v-model="intervention.client" />

                                        <div class="mt-8">
                                            <button
                                                :disabled="loadingUpdateClient"
                                                @click="saveClient"
                                                class="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2.5 rounded-lg shadow"
                                            >
                                                <template v-if="loadingUpdateClient">
                                                    <i class="fas fa-spinner fa-spin"></i>
                                                </template>
                                                <template v-else>
                                                    <i class="fas fa-check mr-1"></i> Modifier
                                                </template>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- Technicien -->
                                    <div v-if="activeTab === 'Technicien'" class="space-y-4">
                                        <h3 class="font-semibold text-gray-700 mb-1">Technicien assigné</h3>
                                        <p v-if="intervention.technicien" class="text-gray-600">
                                            {{ intervention.technicien.prenom }} {{ intervention.technicien?.nom }}
                                            ({{ intervention.technicien.email }})
                                        </p>
                                        <div v-else class="bg-red-50 border-2 border-dashed border-red-300 rounded-lg p-6 text-center">
                                            <i class="fas fa-user-slash text-red-400 text-3xl mb-3 block text-center mx-auto"></i>
                                            <p class="text-red-500 font-medium">Aucun technicien assigné</p>
                                        </div>
                                    </div>

                                    <!-- APPAREIL -->
                                    <div v-if="activeTab === 'Appareil'">
                                        <template v-if="intervention.appareil && intervention.appareil.fournisseur_tel">
                                            <div class="bg-blue-50 p-3 border border-blue-200 rounded-md mb-4">
                                                <p class="text-xs font-medium text-blue-900 mb-0.5">Contact fournisseur</p>
                                                <p class="text-sm font-semibold text-blue-700"><i class="fas fa-tag mr-1"></i> {{ intervention.appareil.fournisseur_tel.marque }}</p>
                                                <p class="text-sm font-semibold text-blue-700"><i class="fas fa-phone mr-1"></i> {{ intervention.appareil.fournisseur_tel.tel }}</p>
                                            </div>
                                        </template>
                                        <appareil-form v-model="intervention.appareil" />

                                        <div class="mt-4">
                                            <button
                                                :disabled="loadingUpdateAppareil"
                                                @click="saveAppareil"
                                                class="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2.5 rounded-lg shadow"
                                            >
                                                <template v-if="loadingUpdateAppareil">
                                                    <i class="fas fa-spinner fa-spin"></i>
                                                </template>
                                                <template v-else>
                                                    <i class="fas fa-check mr-1"></i> Modifier
                                                </template>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- ADRESSE -->
                                    <div v-if="activeTab === 'Adresse'" class="space-y-4">
                                        
                                        <div class="mb-4">
                                            <div id="intervention-map" class="w-full h-56 md:h-64 rounded-lg shadow"></div>
                                        </div>

                                        <adresse-form
                                            v-model="intervention.adresse"
                                            @address-selected="showInterventionMap"
                                        />

                                        <div class="mt-4">
                                            <button
                                                :disabled="loadingUpdateAdresse"
                                                @click="saveAdresse"
                                                class="bg-red-600 hover:bg-red-700 text-white font-semibold px-5 py-2.5 rounded-lg shadow"
                                            >
                                                <template v-if="loadingUpdateAdresse">
                                                    <i class="fas fa-spinner fa-spin"></i>
                                                </template>
                                                <template v-else>
                                                    <i class="fas fa-check mr-1"></i> Modifier
                                                </template>
                                            </button>
                                        </div>
                                    </div>

                                    <!-- CERFA -->
                                    <div v-if="activeTab === 'Cerfa'">
                                        <div class="mb-8">
                                            <template v-if="!intervention.cerfa">
                                                <h2 class="text-lg font-semibold mb-4">Créer un CERFA 15497*04</h2>
                                                <intervention-cerfa-form :intervention-id="intervention.id" @created="getIntervention" />
                                            </template> 
                                            <template v-if="intervention.cerfa">
                                                <div class="bg-green-50 border-2 border-green-200 rounded-lg p-6 mb-4">
                                                    <div class="flex items-center gap-3 mb-3">
                                                        <i class="fas fa-check-circle text-green-600 text-2xl"></i>
                                                        <h3 class="text-lg font-semibold text-green-800">CERFA déjà généré</h3>
                                                    </div>
                                                    <p class="text-green-700 mb-4">Le CERFA 15497*04 a déjà été créé pour cette intervention.</p>
                                                    <a 
                                                        :href="intervention.cerfa.document_url" 
                                                        target="_blank"
                                                        class="inline-flex items-center gap-2 px-5 py-2.5 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg shadow transition-all duration-200"
                                                    >
                                                        <i class="fas fa-external-link-alt"></i>
                                                        Consulter le CERFA
                                                    </a>
                                                </div>
                                                <iframe class="w-full h-[780px]" :src="intervention.cerfa.document_url + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0"></iframe>
                                            </template>
                                        </div>
                                    </div>

                                    <!-- FACTURATION -->
                                    <div v-if="activeTab === 'Facturation'">
                                        <div class="mb-8" v-if="intervention.invoices && intervention.invoices.length > 0">
                                            <h2 class="text-lg font-semibold mb-4">Liste des factures</h2>
                                            <table class="w-full text-sm mb-4">
                                                <thead class="border-b">
                                                    <tr>
                                                        <th class="py-3 px-4 text-left">Numéro</th>
                                                        <th class="py-3 px-4 text-left">Total TTC</th>
                                                        <th class="py-3 px-4 text-left">Statut</th>
                                                        <th class="py-3 px-4 text-left">Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="f in intervention.invoices" :key="f.id" class="border-b cursor-pointer" @click="openInvoiceTab(f.document_url)">
                                                        <td class="py-3 px-4">{{ f.invoice_number }}</td>
                                                        <td class="py-3 px-4">{{ f.total_ttc ? parseFloat(f.total_ttc).toFixed(2) + ' €' : '-' }}</td>
                                                        <td class="py-3 px-4">
                                                            <span :class="['text-white px-2 py-1 rounded text-xs font-semibold', badgeColor(f.status)]">
                                                                {{ getStatusLabel(f.status) }}
                                                            </span>
                                                        </td>
                                                        <td class="py-3 px-4">{{ f.created_at | momentDate }}</td>
                                                    </tr>

                                                    <tr v-if="intervention.invoices.length === 0">
                                                        <td colspan="6" class="text-center py-6 text-gray-500">Aucune facture trouvée…</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <h2 class="text-lg font-semibold mb-4">Ajouter une facture</h2>
                                        <invoice-form :id-intervention="intervention.id" @submit="getIntervention()" />
                                    </div>

                                    <!-- DOCUMENTS -->
                                    <div v-if="activeTab === 'Documents'">
                                        <!-- Add doc -->
                                        <div class="mb-6">
                                            <button 
                                                @click="showAddDocForm = !showAddDocForm"
                                                class="w-full flex items-center justify-between px-6 py-3 bg-white border border-gray-200 rounded-lg transition-all duration-200"
                                            >
                                                <div class="flex items-center gap-2">
                                                    <h3 class="font-bold text-gray-800 text-lg">Ajouter un document</h3>
                                                </div>
                                                <i :class="['fas transition-transform duration-200', showAddDocForm ? 'fa-minus' : 'fa-plus']"></i>
                                            </button>

                                            <transition name="slide-fade">
                                                <div v-if="showAddDocForm" class="mt-4 p-6 bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-xl shadow-md">
                                                    <div class="space-y-4">
                                                        <div>
                                                            <label class="block text-sm font-semibold text-gray-700 mb-2">
                                                                <i class="fas fa-paperclip text-red-500 mr-1"></i> Fichier
                                                            </label>
                                                            <div class="relative">
                                                                <input-file key-name="doc-intervention" v-model="newDoc.url" :preview="false" />
                                                            </div>
                                                        </div>
                                                        
                                                        <div>
                                                            <label class="block text-sm font-semibold text-gray-700 mb-2">
                                                                <i class="fas fa-tag text-red-500 mr-1"></i> Type de document
                                                            </label>
                                                            <div class="relative">
                                                                <select 
                                                                    v-model="newDoc.type" 
                                                                    class="w-full border border-gray-300 rounded-lg px-4 py-3 focus:ring-2 focus:ring-red-500 focus:border-red-500 transition appearance-none bg-white pr-10"
                                                                >
                                                                    <option value="" disabled selected>Sélectionner un type</option>
                                                                    <option v-for="(label, type) in docTypeLabel" :key="type" :value="type">{{ label }}</option>
                                                                </select>
                                                                <i class="fas fa-chevron-down absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none"></i>
                                                            </div>
                                                        </div>
                                                        
                                                        <button :disabled="loadingAddDoc" @click="addDocument" class="w-full md:w-auto px-6 py-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white rounded-lg font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200 flex items-center justify-center gap-2">
                                                            <template v-if="loadingAddDoc">
                                                                <i class="fas fa-spinner fa-spin"></i>
                                                            </template>
                                                            <template v-if="!loadingAddDoc">
                                                                <i class="fas fa-upload"></i> <span>Ajouter le document</span>
                                                            </template>
                                                        </button>
                                                    </div>
                                                </div>
                                            </transition>
                                        </div>

                                        <div>
                                            <div class="flex items-center justify-between mb-4">
                                                <h2 class="text-lg font-semibold">Documents</h2>
                                                <select 
                                                    v-model="selectedDocType" 
                                                    class="w-full md:w-64 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none transition appearance-none bg-white"
                                                >
                                                    <option :value="null">Tous les documents</option>
                                                    <option v-for="(label, type) in docTypeLabel" :key="type" :value="type">
                                                        {{ label }}
                                                    </option>
                                                </select>
                                            </div>

                                            <div v-if="filteredDocuments.length" class="overflow-hidden rounded-xl border border-gray-200 shadow-sm">
                                                <table class="w-full">
                                                    <thead class="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200">
                                                        <tr>
                                                            <th class="px-2 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Type</th>
                                                            <th class="px-2 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Date</th>
                                                            <th class="px-2 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody class="bg-white divide-y divide-gray-200">
                                                        <tr 
                                                            v-for="doc in filteredDocuments" 
                                                            :key="doc.id"
                                                            class="hover:bg-gray-50 transition-colors duration-150"
                                                        >
                                                            <td class="px-2 py-4 whitespace-nowrap">
                                                                <div class="flex items-center gap-3">
                                                                    <span class="text-sm font-medium text-gray-900">{{ docTypeLabel[doc.type] || 'Document' }}</span>
                                                                </div>
                                                            </td>
                                                            <td class="px-2 py-4 whitespace-nowrap">
                                                                <span class="text-sm text-gray-600">{{ doc.created_at | momentDate }}</span>
                                                            </td>
                                                            <td class="px-2 py-4 whitespace-nowrap text-left">
                                                                <a 
                                                                    v-if="doc.url" 
                                                                    :href="doc.url" 
                                                                    target="_blank" 
                                                                    class="inline-flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-semibold rounded-lg shadow-sm transition-all duration-200 hover:shadow-md"
                                                                >
                                                                    <i class="fas fa-external-link-alt text-xs"></i>
                                                                    Consulter
                                                                </a>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div v-else class="text-gray-500 italic">Aucun document disponible.</div>
                                        </div>

                                    </div>

                                    <!-- NOTES -->
                                    <div v-if="activeTab === 'Notes'">
                                        <div v-if="intervention.notes_internes"
                                            class="bg-yellow-50 border border-yellow-200 p-4 rounded-lg shadow-inner text-gray-700"
                                        >
                                            {{ intervention.notes_internes }}
                                        </div>

                                        <div v-else class="text-gray-500 italic">Aucune note interne.</div>
                                    </div>

                                    <!-- HISTORIQUE -->
                                    <div v-if="activeTab === 'Historique'">
                                        <div
                                            v-if="intervention.logs?.length"
                                            class="space-y-3 overflow-y-auto pr-2"
                                        >
                                            <div
                                                v-for="log in intervention.logs"
                                                :key="log.id"
                                                class="border-b pb-3"
                                            >
                                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center">
                                                    <div>
                                                        <div class="text-xs text-gray-500 mb-1">{{ log.created_at | momentDateTime }}</div>
                                                        <div class="font-medium text-gray-700" v-html="log.message"></div>
                                                    </div>
                                                    <div class="text-xs text-gray-500 text-left md:text-right">
                                                        <i class="fas fa-user"></i> {{ log?.account?.prenom }} {{ log?.account?.nom }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else class="text-gray-500 italic">Aucun historique disponible.</div>
                                    </div>


                                    <!-- DEPLANIFIER -->
                                    <div v-if="activeTab === 'Déplanifier'">
                                        <div class="p-6 space-y-4">
                                            <div class="flex items-center justify-between border-b pb-3">
                                                <h2 class="text-lg font-bold text-gray-800">
                                                    Déplanifier l’intervention
                                                </h2>
                                                <button @click="$modal.hide('modal-unplan-intervention')">
                                                    <i class="fas fa-times text-gray-400 hover:text-red-500"></i>
                                                </button>
                                            </div>

                                            <!-- Catégorie -->
                                            <div>
                                                <label class="text-sm font-medium text-gray-700">
                                                    Motif
                                                </label>
                                                <select v-model="unplan.categorie"
                                                    class="mt-1 w-full rounded-lg border border-gray-300 text-sm py-2 px-3">
                                                    <option disabled value="">Sélectionner une catégorie</option>
                                                    <option v-for="(label, key) in categories" :key="key" :value="key">
                                                        {{ label }}
                                                    </option>
                                                </select>
                                            </div>

                                            <!-- Motif -->
                                            <div v-if="unplan.categorie">
                                                <label class="text-sm font-medium text-gray-700">
                                                    Détail du motif
                                                </label>
                                                <select v-model="unplan.motif"
                                                    class="mt-1 w-full rounded-lg border border-gray-300 text-sm py-2 px-3">
                                                    <option disabled value="">Sélectionner un motif</option>
                                                    <option
                                                        v-for="motif in motifs[unplan.categorie]"
                                                        :key="motif"
                                                        :value="motif">
                                                        {{ motif }}
                                                    </option>
                                                </select>
                                            </div>

                                            <!-- Commentaire -->
                                            <div>
                                                <label class="text-sm font-medium text-gray-700">
                                                    Commentaire (optionnel)
                                                </label>
                                                <textarea
                                                    v-model="unplan.commentaire"
                                                    rows="3"
                                                    class="mt-1 w-full rounded-lg border border-gray-300 text-sm p-3"
                                                    placeholder="Détail utile pour le suivi…">
                                                </textarea>
                                            </div>

                                            <!-- Actions -->
                                            <div class="flex justify-end gap-2 pt-4">
                                                <button @click="$modal.hide('modal-unplan-intervention')" class="px-4 py-2 text-sm rounded-lg border border-gray-300">
                                                    Annuler
                                                </button>

                                                <button :disabled="!canSubmitUnplan || loadingUnplan" @click="unplanIntervention" class="px-5 py-2 text-sm rounded-lg text-white font-semibold bg-red-600 hover:bg-red-700 disabled:opacity-50">
                                                    <template v-if="loadingUnplan">
                                                        <i class="fas fa-spinner fa-spin"></i>
                                                    </template>
                                                    <template v-if="!loadingUnplan">
                                                        Confirmer la déplanification
                                                    </template>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import moment from "moment";
import AppareilForm from "../../Client/Components/AppareilForm.vue";
import ClientForm from "../../Client/Components/ClientForm.vue";
import AdresseForm from "../../Client/Components/AdresseForm.vue";
import InvoiceForm from "../../Facturation/Components/InvoiceForm.vue";
import InterventionCerfaForm from '../../Intervention/Components/InterventionCerfaForm.vue';

import DocType from './../../../config/docType.js';

export default {
    props: {
        interventionId: { required: true },
    },
    components: {
        AppareilForm,
        ClientForm,
        AdresseForm,
        InvoiceForm,
        InterventionCerfaForm
    },
    watch: {
        interventionId(newId) {
            this.getIntervention();
        },
        activeTab() {
            this.$nextTick(() => {
                if (this.activeTab === 'Adresse') {
                    this.showInterventionMap();
                }
            });
        }
    },
    data() {
        return {
            docTypeLabel: DocType,
            activeTab: 'Infos',
            tabs: [
                { label: 'Infos', icon: 'fas fa-info-circle' },
                { label: 'Client', icon: 'fas fa-user' },
                { label: 'Technicien', icon: 'fas fa-user-cog' },
                { label: 'Appareil', icon: 'fas fa-microchip' },
                { label: 'Adresse', icon: 'fas fa-map-marker-alt' },
                // { label: 'Cerfa', icon: 'fas fa-file-signature' },
                // { label: 'Facturation', icon: 'fas fa-file-invoice' },
                { label: 'Documents', icon: 'fas fa-file' },
                // { label: 'Notes', icon: 'fas fa-sticky-note' },
                { label: 'Historique', icon: 'fas fa-history' },
            ],
            intervention: null,
            loadingGetIntervention: false,

            showAddDocForm: false,
            newDoc: {
                url: '',
                type: ''
            },

            selectedDocType: null,

            loadingUpdateAppareil: false,
            loadingUpdateClient: false,
            loadingUpdateAdresse: false,
            loadingAddDoc: false,

            // Déplanification
            unplan: {
                categorie: '',
                motif: '',
                commentaire: ''
            },

            categories: {
                client: 'Client',
                technique: 'Technique',
                organisation: 'Organisation',
                urgent: 'Urgent',
                technicien: 'Technicien'
            },

            motifs: {
                client: [
                    'Client absent',
                    'Client injoignable',
                    'Client a annulé',
                    'Accès impossible',
                    'Mauvaise adresse'
                ],
                technique: [
                    'Manque de pièce',
                    'Panne véhicule',
                    'Outils manquants',
                    'Problème technique imprévu'
                ],
                organisation: [
                    'Erreur de planification',
                    'Double réservation',
                    'Priorité modifiée',
                    'Intervention urgente ajoutée'
                ],
                urgent: [
                    'Urgence prioritaire',
                    'Accident',
                    'Conditions météo'
                ],
                technicien: [
                    'Maladie',
                    'Absence imprévue',
                    'Fatigue / sécurité'
                ]
            },
            loadingUnplan: false,
        };
    },
    computed: {
        docDisplayImg() {
            return ['photo', 'photo_intervention'];
        },

        modalWidth() {
            return window.innerWidth < 768 ? '100%' : '900px'; 
        },
        filteredDocuments() {
            if (!this.intervention || !this.intervention.documents) return [];

            if (this.selectedDocType) {
                return this.intervention.documents.filter(doc => doc.type === this.selectedDocType);
            }
            return this.intervention.documents;
        },

        canSubmitUnplan() {
            return this.unplan.categorie && this.unplan.motif;
        },
        
        emptySignature() {
            let codes = ['a_planifier', 'planifie'];
            if (this.intervention && !codes.includes(this.intervention.status_code) && !this.intervention.signature_client) {
                return true;
            }
            return false
        }
    },
    filters: {
        momentDate(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY')
            }
            return '-'
        },
        momentDateTime(date) {
            if (date) {
                return moment(date).format('DD/MM/YYYY HH:mm')
            }
            return '-'
        }
    },
    methods: {
        statusClass(code) {
            return {
                'a_planifier': 'bg-orange-100 text-orange-800',
                'planifie': 'bg-red-100 text-red-800',
                'en_cours': 'bg-yellow-100 text-yellow-800',
                'termine': 'bg-red-100 text-red-800'
            }[code] || 'bg-slate-100 text-slate-800';
        },
        async getIntervention(loading = true) {
            this.activeTab = 'Infos';
            if (loading) {
                this.loadingGetIntervention = true;
            }
            let response = await this.$request.get('/interventions/' + this.interventionId);

            if (response) {
                this.intervention = response
                // this.$nextTick(() => {
                //     setTimeout(() => {
                //         this.showInterventionMap();
                //     }, 200);
                // });
            }

            // Init unplan
            this.unplan = {
                categorie: '',
                motif: '',
                commentaire: ''
            };

            this.loadingGetIntervention = false;
        },
        showInterventionMap() {
            if (!this.intervention || !this.intervention || !this.intervention.adresse) return;
            const adr = this.intervention.adresse;
            if (!adr || !adr.latitude || !adr.longitude) return;

            mapboxgl.accessToken = 'pk.eyJ1IjoidmljdG9yYW53IiwiYSI6ImNrajhuam1iOTZ1dnQydnFqbzRldDJrdW8ifQ.VkIKVhh5_Pcp7PxqQ-GCCg';

            window.setTimeout(() => {
                if (this._interventionMap) {
                    this._interventionMap.remove();
                }

                this._interventionMap = new mapboxgl.Map({
                    container: 'intervention-map',
                    style: 'mapbox://styles/mapbox/streets-v12',
                    center: [parseFloat(adr.longitude), parseFloat(adr.latitude)],
                    zoom: 14
                });

                new mapboxgl.Marker({ color: '#e11d48' })
                    .setLngLat([parseFloat(adr.longitude), parseFloat(adr.latitude)])
                    .addTo(this._interventionMap);
            }, 400);
        },

        async unplanIntervention() {
            if (!this.intervention) return;
            
            this.loadingUnplan = true;
            let response = await this.$request.post('/interventions/' + this.intervention.id + '/deplanifier', {
                motif: this.unplan.categorie + ' - ' + this.unplan.motif + (this.unplan.commentaire ? ' - ' + this.unplan.commentaire : ''),
            });
            this.loadingUnplan = false;

            if (response) {
                this.$toast.success("Intervention déplanifiée");
                this.intervention = null;
                this.$modal.hide('modal-view-intervention-' + this.interventionId);
                this.$emit('unplanned');
                // await this.getInterventionsUnplanned();
                // await this.getInterventions();
                // this.initScheduler();
            }
        },

        async saveAppareil() {
            const validation = this.$inpError([
                'inp-type:required|min=3',
                'inp-marque:nullable|min=2',
                'inp-modele:nullable|min=2',
                'inp-numero_serie:nullable|min=3'
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }

            try {
                this.loadingUpdateAppareil = true;
                this.intervention.appareil.client_id = this.intervention.client.id;
                await this.$request.post('/client-appareils/' + this.intervention.appareil.id, this.intervention.appareil);
                this.loadingUpdateAppareil = false;
                this.$toast.success("Appareil modifié avec succès");
            } catch (e) {
                this.loadingUpdateAppareil = false;
                this.$toast.error("Erreur lors de l'enregistrement de l'appareil");
            }
        },
        async saveClient() {
            const id = this.$route.params.id

            const validation = this.$inpError([
                'inp-nom:required|min=3',
                'inp-email:required|email',
                'inp-siret:nullable|siret',
                'inp-telephone:required|tel',
                // 'inp-adresse1:required|min=5',
                // 'inp-code_postal:required|postal',
                // 'inp-ville:required|min=2',
                // 'inp-pays:required|min=2'
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }
            try {
                await this.$request.post(`/clients/${id}`, this.client)
                this.$toast.success('Client mis à jour')
            } catch (e) {
                this.$toast.error('Erreur lors de la mise à jour du client')
            }
        },

        async saveAdresse() {
            const id = this.intervention.adresse.id

            const validation = this.$inpError([
                'inp-adresse1:required|min=5',
                'inp-code_postal:required|postal',
                'inp-ville:required|min=2',
                'inp-pays:required|min=2'
            ]);

            if (!validation) {
                this.$toast.error('Formulaire invalide')
                return
            }
            try {
                this.loadingUpdateAdresse = true
                await this.$request.post(`/clients/${id}/adresses`, this.intervention.adresse)
                this.$toast.success('Adresse mise à jour')
                this.showInterventionMap()
                this.loadingUpdateAdresse = false
            } catch (e) {
                this.$toast.error('Erreur lors de la mise à jour de l\'adresse')
            }
        },

        getStatusLabel(s) {
            return s === "draft" ? "Brouillon"
                : s === "issued" ? "Émise"
                : s === "cancelled" ? "Annulée"
                : s === "paid" ? "Payée"
                : s === "sent" ? "Envoyée"
                : s;
        },

        badgeColor(s) {
            return s === "draft" ? "bg-gray-500"
                : s === "issued" ? "bg-blue-500"
                : s === "cancelled" ? "bg-red-600"
                : s === "paid" ? "bg-green-600"
                : s === "sent" ? "bg-yellow-500"
                : "bg-gray-500";
        },

        openInvoiceTab(url) {
            window.open(url, '_blank');
        },

        async addDocument() {
            if (!this.newDoc.url) {
                this.$toast.error("Veuillez sélectionner un fichier à télécharger.");
                return;
            }
            if (!this.newDoc.type) {
                this.$toast.error("Veuillez sélectionner un type de document.");
                return;
            }

            this.loadingAddDoc = true
            await this.$request.post('/interventions/add-doc', {
                intervention_id: this.intervention.id,
                url: this.newDoc.url,
                type: this.newDoc.type || 'autre'
            });
            this.loadingAddDoc = false

            this.newDoc = {};

            this.$toast.success("Document ajouté avec succès.");
            this.getIntervention(false);
        },
        
        async sendSignature() {
            if (!this.intervention) return;

            if (confirm("Êtes-vous sûr de vouloir envoyer une demande de signature au client ?")) {
                let response = await this.$request.post('/interventions/request-signature', {
                    intervention_id: this.intervention.id
                });
    
                if (response) {
                    this.$toast.success("Demande de signature envoyée au client.");
                }
            }

        }
    },
    mounted() {
        this.getIntervention();
    },
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.25s ease;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>